import { type ThunkDispatch } from "redux-thunk";
import { showRequestWeight } from "../../../Actions/SellScreen/SellScreenProductActions";
import PopupManager from "../../../Common/Popups/PopupManager";
import Scales, { ScalesNotEnabledError } from "./Scales";

(globalThis as any).scales = Scales;

export async function weigh(dispatch: ThunkDispatch<any, any, any>): Promise<number> {
    let weight = 0;

    try {
        weight = await Scales.getWeight();
    } catch(e) {
        try {
            if(e instanceof ScalesNotEnabledError) {
                await Scales.enable();
                weight = await Scales.getWeight();
            } else {
                console.error("Could not read weight from the scales", e);
            }
        } catch(e) {
            if(e instanceof ScalesNotEnabledError) {
                PopupManager.warning("Scales are not enabled for this device");
            } else {
                console.error("Could not read weight from the scales", e);
            }
        }
    }

    if(weight === 0) {
        return new Promise(res => {
            dispatch(showRequestWeight(res));
        });
    }

    return weight;
}
